const Footer = () => {
    return (
        <>
            <div className="mt-16 py-6 text-center border-t-2">
                <div className="font-medium">© 2022 STUDEZAM.</div>
                <div className="font-light">Website dự thi THT SPST</div>
            </div>
        </>
    )
}

export default Footer
